/**
 * Savaş sahnesi yerleşimi — yandan bakış.
 *
 * İzometrik (üstte düşman, altta oyuncu) düzen denendi ve bırakıldı:
 * referans oyun yandan bakışlı bir sahne kullanıyor ve bu düzen hem
 * karakterleri daha büyük gösteriyor hem "karşı karşıya" hissi veriyor.
 *
 *        ARKA   ÖN                    ÖN   ARKA
 *          ·     ·      | orta |       ·     ·
 *        oyuncu (sol)            düşman (sağ)
 */

export type Yan = 'sol' | 'sag'

/** Merkeze olan yatay uzaklıklar. */
export const ON_SAF_X = 148
export const ARKA_SAF_X = 318

/** Aynı saftaki birimler arası dikey aralık. */
/**
 * Aynı saftaki birimler arası dikey aralık.
 * Birim yüksekliğinden (≈105 px) büyük olmalı; aksi halde alttaki birimin
 * başı üsttekinin ad etiketiyle çakışır.
 */
export const DIKEY_ARALIK = 118

/**
 * Derinlik yanılsaması: aşağıdaki birim merkeze doğru kayar, böylece
 * aynı saftaki birimler dikey bir sütun değil çapraz bir dizilim oluşturur.
 */
export const DERINLIK_KAYMASI = 54

/** Birimlerin dizildiği taban. Sahne kökü zaten aşağıda konumlandırılır. */
export const TABAN_Y = 0

export function safX(yan: Yan, saf: 'on' | 'arka'): number {
  const uzaklik = saf === 'on' ? ON_SAF_X : ARKA_SAF_X
  return yan === 'sol' ? -uzaklik : uzaklik
}

/** Oyuncunun tarafı her zaman solda gösterilir. */
export function birimYani(oyuncuTarafi: 'a' | 'b', taraf: 'a' | 'b'): Yan {
  return taraf === oyuncuTarafi ? 'sol' : 'sag'
}

export function birimKonumu(
  yan: Yan, saf: 'on' | 'arka', indeks: number, sayi: number,
): { x: number; y: number } {
  const merkezleme = (sayi - 1) / 2
  const basamak = indeks - merkezleme
  const yon = yan === 'sol' ? 1 : -1
  return {
    x: safX(yan, saf) + basamak * DERINLIK_KAYMASI * yon,
    y: TABAN_Y + basamak * DIKEY_ARALIK,
  }
}

/** Aşağıdaki birim önde çizilir; ölçek de hafifçe büyür (yakınlık hissi). */
export function birimOlcegi(y: number): number {
  return 1.0 + (y - TABAN_Y) / 700
}
